<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <div class="plate">
        <div class="title">申请信息</div>
        <div class="apply-info">
          <div class="status">
            <img src="@/assets/icon-status-audit.png" />
            <p>待审核</p>
          </div>
          <div class="info">
            <span>注册申请时间：{{ form.applyTime }}</span>
            <span>联系人姓名：{{ form.liaisonName }}</span>
            <span>注册手机号：{{ form.loginMobile }}</span>
          </div>
        </div>
        <!-- <div class="tip-txt">
          <p>该手机号在其他系统注册，使用相同密码即可登录，若已忘记，可注册成功后进行重置密码。</p>
          <p>初始密码为“手机号”+“360”，可在注册成功后进行重置密码。</p>
        </div> -->
      </div>

      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        :inline="true"
        label-width="150px"
        class="form"
        :validate-on-rule-change="false"
      >
        <div class="plate">
          <div class="title">合作社信息</div>
          <el-form-item class="w100" label="营业执照">
            <el-upload
              class="upload-large"
              id="businessLicense"
              :action="'#'"
              accept="image/jpeg,image/gif,image/png"
              :multiple="false"
              :show-file-list="false"
              list-type="picture-card"
              :on-preview="handlePreviewImg"
              :data="{ xtype: 'ysb_product', type: 'image' }"
              :on-success="
                (file) => handleImgSuccess(file, 'businessLicenseUrl')
              "
              :http-request="handleCustomUpload"
            >
              <!-- <div class="uploadbox" > -->
              <img
                v-if="form.businessLicenseUrl == ''"
                class="place-img"
                src="@/assets/upload-bussiness.png"
              />
              <img v-else :src="form.businessLicenseUrl" />
              <!-- </div> -->
            </el-upload>
          </el-form-item>
          <el-form-item
            prop="cooperativeName"
            label="名称"
            ref="cooperativeName"
          >
            <el-input
              placeholder="请输入名称"
              v-model.trim="form.cooperativeName"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="socialCreditCode"
            label="统一社会信用代码"
            ref="socialCreditCode"
          >
            <el-input
              placeholder="请输入统一社会信用代码"
              v-model.trim="form.socialCreditCode"
            ></el-input>
          </el-form-item>
          <el-form-item label="所在地区" prop="provinceId" ref="provinceId">
            <el-cascader
              ref="regionCascader"
              :options="regionData"
              :props="regionProps"
              v-model="checkedRegionData"
              placeholder="请选择所在地区"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="住所">
            <el-input
              placeholder="请输入住所"
              v-model.trim="form.address"
            ></el-input>
          </el-form-item>
          <el-form-item label="法定代表人" prop="corName" ref="corName">
            <el-input
              placeholder="请输入法定代表人"
              v-model.trim="form.corName"
            ></el-input>
          </el-form-item>
          <el-form-item label="法定代表人电话" prop="corMobile" ref="corMobile">
            <el-input
              placeholder="请输入法定代表人电话"
              v-model.trim="form.corMobile"
            ></el-input>
          </el-form-item>
          <el-form-item label="成员出资总额">
            <el-input
              placeholder="请输入成员出资总额"
              v-model.trim="form.registeredCapital"
            ></el-input>
          </el-form-item>
          <el-form-item label="成立时间">
            <el-date-picker
              v-model="form.foundingTime"
              type="date"
              placeholder="请选择成立时间"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <br />
          <el-form-item label="地图位置" prop="centre" class="map-form-item">
            <el-button
              type="primary"
              plain
              icon="el-icon-plus"
              class="btn-add"
              @click="openQueryMap"
            >
              点击编辑所在位置
            </el-button>
            <span class="map-address" v-if="centreAddress">
              地图位置
              <i></i> <span>{{ centreAddress }}</span>
            </span>
          </el-form-item>
        </div>

        <div class="plate">
          <div class="title">理事长信息</div>
          <el-form-item label="身份证" style="width: 100%">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-upload
                  class="upload-large"
                  id="cardPortraitUrl"
                  :action="'#'"
                  accept="image/jpeg,image/gif,image/png"
                  :multiple="false"
                  :show-file-list="false"
                  list-type="picture-card"
                  :on-preview="handlePreviewImg"
                  :data="{ xtype: 'ysb_product', type: 'image' }"
                  :on-success="
                    (file) => handleImgSuccess(file, 'cardPortraitUrl')
                  "
                  :http-request="handleCustomUpload"
                >
                  <!-- <div class="uploadbox-big"> -->
                  <img
                    v-if="!form.cardPortraitUrl"
                    class="place-img"
                    src="@/assets/upload-idcard-portrait.png"
                  />
                  <img v-else :src="form.cardPortraitUrl" alt="" />
                  <!-- </div> -->
                </el-upload>
              </el-col>
              <el-col :span="12">
                <el-upload
                  class="upload-large"
                  id="cardEmblemUrl"
                  :action="'#'"
                  accept="image/jpeg,image/gif,image/png"
                  :multiple="false"
                  :show-file-list="false"
                  list-type="picture-card"
                  :on-preview="handlePreviewImg"
                  :data="{ xtype: 'ysb_product', type: 'image' }"
                  :on-success="
                    (file) => handleImgSuccess(file, 'cardEmblemUrl')
                  "
                  :http-request="handleCustomUpload"
                >
                  <!-- <div class="uploadbox-big"> -->
                  <img
                    v-if="!form.cardEmblemUrl"
                    class="place-img"
                    src="@/assets/upload-idcard-emblem.png"
                  />
                  <img v-else :src="form.cardEmblemUrl" alt="" />
                  <!-- </div> -->
                </el-upload>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item label="理事长姓名">
            <el-input
              placeholder="请输入理事长姓名"
              v-model.trim="form.directorName"
              maxlength="30"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="身份证号码"
            prop="directorIdCard"
            ref="directorIdCard"
          >
            <el-input
              placeholder="请输入身份证号码"
              v-model.trim="form.directorIdCard"
            ></el-input>
          </el-form-item>
          <el-form-item label="住址">
            <el-input
              placeholder="请输入住址"
              v-model.trim="form.directorAddress"
            ></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="directorMobile" ref="directorMobile">
            <el-input
              placeholder="请输入电话"
              v-model.trim="form.directorMobile"
            ></el-input>
          </el-form-item>
          <el-form-item class="w100" label="头像照片">
            <el-upload
              class="upload-small"
              :action="'#'"
              accept="image/jpeg,image/gif,image/png"
              :multiple="false"
              :show-file-list="false"
              list-type="picture-card"
              :on-preview="handlePreviewImg"
              :data="{ xtype: 'ysb_product', type: 'image' }"
              :on-success="(file) => handleImgSuccess(file, 'directorHeadUrl')"
              :http-request="handleCustomUpload"
            >
              <!-- <div class="uploadbox-small" > -->
              <i v-if="!form.directorHeadUrl" class="el-icon-plus"></i>
              <img v-else :src="form.directorHeadUrl" alt="" />
              <!-- </div> -->
            </el-upload>
          </el-form-item>
        </div>
        <div class="plate">
          <div class="title">合作社荣誉信息<label>（可上传多张）</label></div>
          <el-form-item class="w100" label="荣誉证书">
            <el-upload
              class="upload-small"
              :action="'#'"
              accept="image/jpeg,image/gif,image/png"
              :multiple="true"
              :limit="10"
              :show-file-list="true"
              list-type="picture-card"
              :file-list="honorFileList"
              :on-preview="handlePreviewImg"
              :on-remove="(file) => handleRemoveImg(file, 'honor')"
              :on-exceed="handleExceed"
              :data="{ xtype: 'ysb_product', type: 'image' }"
              :on-success="(file) => handleImgSuccess(file, 'honor')"
              :http-request="handleCustomUpload"
            >
              <!-- <div class="uploadbox-small" > -->
              <i class="el-icon-plus"></i>
              <!-- </div> -->
            </el-upload>
          </el-form-item>
        </div>
        <div class="plate">
          <div class="title">
            合作社经营场地信息<label>（可上传多张）</label>
          </div>
          <el-form-item class="w100" label="经营场地信息">
            <el-upload
              class="upload-small"
              :action="'#'"
              accept="image/jpeg,image/gif,image/png"
              :multiple="true"
              :limit="10"
              :on-exceed="handleExceed"
              :show-file-list="true"
              list-type="picture-card"
              :file-list="premisesFileList"
              :on-preview="handlePreviewImg"
              :on-remove="(file) => handleRemoveImg(file, 'premises')"
              :data="{ xtype: 'ysb_product', type: 'image' }"
              :on-success="(file) => handleImgSuccess(file, 'premises')"
              :http-request="handleCustomUpload"
            >
              <!-- <div class="uploadbox-small" > -->
              <i class="el-icon-plus"></i>
              <!-- </div> -->
            </el-upload>
          </el-form-item>
        </div>
        <div class="plate">
          <div class="title">业务负责人</div>
          <el-form-item
            prop="businessZoneId"
            label="业务区域"
            ref="businessZoneId"
          >
            <el-cascader
              ref="regionCascader"
              :options="businessZoneList"
              :props="zoneProps"
              v-model="checkedZone"
              placeholder="请选择业务区域"
              @change="zoneChange"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item
            prop="businessPersonId"
            label="业务员"
            ref="businessPersonId"
          >
            <el-select
              placeholder="请选择业务员"
              v-model="form.businessPersonId"
            >
              <el-option
                v-for="item in dutyPersonList"
                :key="item.id"
                :label="item.personName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <div class="foot-btns">
        <el-button type="primary" class="btn-cancel" @click="$router.go(-1)"
          >取消</el-button
        >
        <el-button
          type="primary"
          class="btn-cancel"
          @click="handleSubmit('form', 2)"
          >暂存</el-button
        >
        <el-button type="primary" class="btn-refuse" @click="handleRefuse()"
          >拒绝</el-button
        >
        <el-button
          type="primary"
          class="btn-pass"
          :disabled="submitFlag"
          @click="handleSubmit('form', 4)"
          >通过
        </el-button>
      </div>
    </div>
    <el-dialog
      :visible.sync="refusePopVisible"
      title="拒绝申请"
      width="650px"
      class="dialog-refuse"
    >
      <div class="top">您将拒绝该账号注册，请填写拒绝原因。</div>
      <el-form
        :inlline="true"
        label-width="100px"
        :model="refuseForm"
        :rules="refuseRules"
        ref="refuseForm"
      >
        <el-form-item label="拒绝原因" prop="auditRemark">
          <el-input
            type="textarea"
            :rows="3"
            v-model.trim="refuseForm.auditRemark"
          ></el-input>
        </el-form-item>
        <el-form-item class="foot-btns">
          <el-button
            type="primary"
            class="btn-cancel"
            @click="refusePopVisible = false"
            >取消</el-button
          >
          <el-button type="primary" @click="refuseSubmit()">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="previeImgVisible" title="图片预览">
      <div class="previewImg">
        <img class="img" width="100%" :src="previewImgUrl" alt="" />
      </div>
    </el-dialog>
    <!-- 选择地图位置组件 -->
    <QueryMap ref="queryMap" @onConfirmSelectAddress="onConfirmSelectAddress" />
  </el-main>
</template>

<script>
import regionSeatLibs from "utils/regionSeatLibs";
let regionData = JSON.parse(JSON.stringify(regionSeatLibs[0].c));
import { uploadImg } from "@/api/uploadImg";
import QueryMap from "@/components/QueryMap/index";
export default {
  name: "CooperativeApplyExamine",
  components: {
    QueryMap,
  },
  data() {
    const validateIdCard = (rule, value, callback) => {
      if (value && value.length != 18) {
        callback(new Error("请输入正确的身份证号"));
      } else {
        callback();
      }
    };
    const validateMobile = (rule, value, callback) => {
      let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (value && !reg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    return {
      cooApplyId: "", //合作社申请id
      centreAddress: "",
      form: {
        applyTime: "", //申请时间
        liaisonName: "", //联系人
        loginMobile: "", //注册手机号
        cooperativeName: "", //合作社名称
        socialCreditCode: "" /*统一社会信用代码*/,
        corName: "" /*法人代表姓名*/,
        corMobile: "" /*法人代表电话*/,
        registeredCapital: null /*出资总额*/,
        foundingTime: null /*成立时间*/,
        address: "" /*详细地址-住所*/,
        businessLicenseUrl: "" /*营业执照url*/,
        provinceId: "" /*省id*/,
        provinceName: "",
        cityId: "",
        cityName: "",
        areaId: "",
        areaName: "",
        identityId: null,
        directorName: null /*理事长姓名*/,
        directorIdCard: null /*理事长身份证号码*/,
        directorAddress: null /*理事长住址*/,
        directorMobile: null /*理事长电话*/,
        directorHeadUrl: null /*理事长头像照片*/,
        cardPortraitUrl: null /*身份证人像url*/,
        cardEmblemUrl: null /*身份证国徽url*/,
        businessZoneId: null /*业务区域id*/,
        businessPersonId: null /*业务员id*/,
        applyStatus: 2 /*状态 2  待审核 3 审核拒绝 4 审核通过*/,
        auditType: "" /*审核类型2-暂存 3-拒绝 4-通过*/,
        centre: "",
      },
      honorFileList: [], //荣誉图片-回显
      cooHonorFileList: [], //荣誉图片
      premisesFileList: [], //经营场地图片-回显
      cooBusinessPlaceFileList: [], //经营场地图片
      businessZoneList: [], //业务区域数据
      zoneProps: {
        value: "id",
        label: "zoneName",
        children: "children",
      },
      checkedZone: [], //选中的业务区域
      dutyPersonList: [], //业务负责人数据
      checkedRegionData: [],
      regionProps: {
        value: "i",
        label: "n",
        children: "c",
      },
      regionData,
      rules: {
        cooperativeName: {
          required: true,
          message: "请输入合作社名称",
          trigger: "blur",
        },
        centre: [
          { required: true, message: "请点击编辑所在位置", trigger: "change" },
        ],
        socialCreditCode: {
          required: true,
          message: "请输入统一社会信用代码",
          trigger: "blur",
        },
        provinceId: {
          required: true,
          message: "请选择所在地区",
          trigger: "change",
        },
        corName: {
          required: true,
          message: "请输入法定代表人",
          trigger: "blur",
        },
        corMobile: {
          required: true,
          message: "请输入法定代表人电话",
          trigger: "blur",
        },
        businessZoneId: {
          required: true,
          message: "请选择业务区域",
          trigger: "change",
        },
        businessPersonId: {
          required: true,
          message: "请选择业务员",
          trigger: "change",
        },
        directorIdCard: { validator: validateIdCard, trigger: "blur" },
        directorMobile: { validator: validateMobile, trigger: "blur" },
      },
      previewImgUrl: "", //预览图片url
      previeImgVisible: false, //预览图片弹框
      submitFlag: false,
      refusePopVisible: false, //拒绝弹框显示/隐藏
      refuseForm: {
        auditRemark: "",
      },
      refuseRules: {
        auditRemark: {
          required: true,
          message: "请输入拒绝原因",
          trigger: "blur",
        },
      },
    };
  },
  watch: {
    checkedRegionData(newVal) {
      this.form.provinceId = newVal[0] || "";
      this.form.cityId = newVal[1] || "";
      this.form.areaId = newVal[2] || "";
      let regionNames =
        newVal.length > 0 ? this.handleRegionName(newVal) : ["", "", ""];
      this.form.provinceName = regionNames[0];
      this.form.cityName = regionNames[1];
      this.form.areaName = regionNames[2];
      if (newVal.length > 0) {
        this.$refs["form"].clearValidate("provinceId");
      }
    },
    // checkedZone(newVal) {
    //   this.form.businessZoneId = newVal.length > 0 ? newVal[newVal.length - 1] : "";
    //   newVal.length > 0 && this.getDutyPerson();
    // },
  },
  created() {
    this.cooApplyId = this.$route.query.cooApplyId;
    this.getCooperativeApplyInfo();
  },
  beforeRouteEnter(to, from, next) {
    let targetPath = "";
    switch (to.query.dataSource) {
      case "2":
        targetPath = "/cooperative/apply-examine/list";
        break;
      case "3":
        targetPath = "/cooperative/apply-examine/batch";
        break;
    }
    to.meta.targetPath = targetPath;
    next((vm) => {});
  },
  methods: {
    zoneChange(newVal) {
      this.form.businessPersonId = "";
      this.form.businessZoneId =
        newVal.length > 0 ? newVal[newVal.length - 1] : "";
      newVal.length > 0 && this.getDutyPerson();
    },
    // 拒绝
    handleRefuse() {
      this.refusePopVisible = true;
      this.refuseForm.auditRemark = "";
    },
    refuseSubmit() {
      this.$refs.refuseForm.validate((valid, object) => {
        if (valid) {
          this.form.auditRemark = this.refuseForm.auditRemark;
          this.cooperativeAudit(3);
          this.refusePopVisible = false;
        }
      });
    },
    // 获取审核信息
    getCooperativeApplyInfo() {
      this.$http.cooperative
        .getCooperativeApplyInfo({ cooApplyId: this.cooApplyId })
        .then((res) => {
          this.form = { ...this.form, ...res.data };
          this.getBusinessZoneData();
          let { provinceId, cityId, areaId } = res.data;
          if (provinceId && cityId) {
            // 地区回显赋值
            let checkedRegionData = [provinceId, cityId];
            areaId && checkedRegionData.push(areaId);
            this.checkedRegionData = checkedRegionData;
          }
          // 业务区域有值时 获取业务员数据
          res.data.businessZoneId && this.getDutyPerson();

          //荣誉证书和经营场地回显赋值
          if (
            res.data.cooHonorFileList &&
            res.data.cooHonorFileList.length > 0
          ) {
            let honorFileList = res.data.cooHonorFileList.map((item) => {
              return {
                id: item.id,
                applyId: item.applyId,
                fileType: 2,
                url: item.picPath,
                name: item.fileName,
                status: "success",
              };
            });
            this.honorFileList = JSON.parse(JSON.stringify(honorFileList));
            this.cooHonorFileList = JSON.parse(JSON.stringify(honorFileList));
          }
          if (
            res.data.cooBusinessPlaceFileList &&
            res.data.cooBusinessPlaceFileList.length > 0
          ) {
            let premisesFileList = res.data.cooBusinessPlaceFileList.map(
              (item) => {
                return {
                  id: item.id,
                  applyId: item.applyId,
                  fileType: 3,
                  url: item.picPath,
                  name: item.fileName,
                  status: "success",
                };
              }
            );
            this.premisesFileList = JSON.parse(
              JSON.stringify(premisesFileList)
            );
            this.cooBusinessPlaceFileList = JSON.parse(
              JSON.stringify(premisesFileList)
            );
          }
        });
    },
    // 根据地区id查询name
    handleRegionName(ids) {
      let province = this.regionData.filter((item) => item.i == ids[0])[0];
      let city = province.c.filter((item) => item.i == ids[1])[0];
      let areaName = ids[2]
        ? city.c.find((item) => item.i == ids[2])
          ? city.c.find((item) => item.i == ids[2]).n
          : ""
        : "";
      return [province.n, city.n, areaName];
    },
    // 根据最后一级业务区域id查找完整id-用于页面回显
    handleZoneIds(list, id, zoneIds) {
      if (!zoneIds) zoneIds = [];
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        zoneIds.push(item.id);
        if (item.id == id) return zoneIds;
        if (item.children && item.children.length > 0) {
          return this.handleZoneIds(item.children, id, zoneIds);
        }
      }
    },
    // 获取业务区域数据
    getBusinessZoneData() {
      this.$http.common.getBusinessZoneList({}).then((res) => {
        let data = res.data;
        this.businessZoneList = data;
        let businessZoneId = this.form.businessZoneId;
        // 业务区域回显赋值
        if (businessZoneId) {
          for (let i = 0; i < data.length; i++) {
            if (data[i].id == businessZoneId) {
              this.checkedZone = [businessZoneId];
              break;
            } else {
              if (data[i].children && data[i].children.length > 0) {
                this.checkedZone = this.handleZoneIds(
                  data[i].children,
                  businessZoneId,
                  [data[i].id]
                );
              }
            }
          }
        }
      });
    },
    // 获取业务负责人
    getDutyPerson() {
      this.$http.common
        .getDutyPerson({ businessZoneId: this.form.businessZoneId })
        .then((res) => {
          this.dutyPersonList = res.data;
        });
    },
    // 身份证识别
    disIdcard(imageUrl, type) {
      let LoadingInstance = this.$loading({
        target: document.getElementById(type),
        text: "识别中...",
        background: "rgba(0,0,0,.5)",
      });
      this.$http.common
        .disIdcard({ imageUrl: imageUrl })
        .then((res) => {
          LoadingInstance.close();
          this.form[type] = imageUrl;
          if (type == "cardPortraitUrl") {
            let cards = res.data.cards;
            this.form.directorName = cards.name;
            this.form.directorIdCard = cards.id_num;
            this.form.directorAddress = cards.address;
          }
        })
        .catch(() => {
          LoadingInstance.close();
        });
    },

    //营业执照识别
    disBusinessLicense(imageUrl) {
      let LoadingInstance = this.$loading({
        target: document.getElementById("businessLicense"),
        text: "识别中...",
        background: "rgba(0,0,0,.5)",
      });
      this.$http.common
        .disBusinessLicense({ imageUrl: imageUrl })
        .then((res) => {
          LoadingInstance.close();
          let license = res.data.license;
          this.form.cooperativeName = license.name;
          this.form.socialCreditCode = license.reg_num;
          this.form.corName = license.legal_person;
          this.form.address = license.address;
          this.form.registeredCapital = license.capital;
          this.form.foundingTime = license.start_date;
        })
        .catch(() => {
          LoadingInstance.close();
        });
    },

    //提交
    handleSubmit(formName, handleType) {
      this.$refs[formName].validate((valid, object) => {
        if (valid) {
          this.cooperativeAudit(handleType);
        } else {
          for (let i in object) {
            let dom = this.$refs[i];
            if (dom) {
              if (Object.prototype.toString.call(dom) !== "[object Object]") {
                //这里是针对遍历的情况（多个输入框），取值为数组
                dom = dom[0];
              }
              dom.$el.scrollIntoView({
                //滚动到指定节点
                block: "end", //值有start,center,end，nearest，当前显示在视图区域中间
                behavior: "smooth", //值有auto、instant,smooth，缓动动画（当前是慢速的）
              });
            }
          }
          this.submitFlag = false;
          return false;
        }
      });
    },
    // 审核操作
    cooperativeAudit(handleType) {
      this.submitFlag = true;
      this.form.auditType = handleType;
      let cooHonorFileList = this.cooHonorFileList.map((item) => {
        return {
          id: item.id || "",
          applyId: item.applyId || "",
          fileName: item.name,
          picPath: item.url,
          fileType: 2,
        };
      });
      let cooBusinessPlaceFileList = this.cooBusinessPlaceFileList.map(
        (item) => {
          return {
            id: item.id || "",
            applyId: item.applyId || "",
            fileName: item.name,
            picPath: item.url,
            fileType: 3,
          };
        }
      );
      let params = {
        ...this.form,
        cooHonorFileList: cooHonorFileList,
        cooBusinessPlaceFileList: cooBusinessPlaceFileList,
      };
      this.$http.cooperative
        .cooperativeAudit(params)
        .then((res) => {
          this.$message.success("审核成功");
          this.$router.go(-1);
          this.submitFlag = false;
        })
        .catch((err) => {
          this.submitFlag = false;
        });
    },
    //预览图片
    handlePreviewImg(file) {
      this.previewImgUrl = file.response ? file.response.url : file.url;
      this.previeImgVisible = true;
    },
    // 删除图片
    handleRemoveImg(file, type) {
      let url = file.response ? file.response.url : file.url;
      switch (type) {
        case "honor":
          this.cooHonorFileList = this.cooHonorFileList.filter(
            (item) => item.url != url
          );
          break;
        case "premises":
          this.cooBusinessPlaceFileList = this.cooBusinessPlaceFileList.filter(
            (item) => item.url != url
          );
          break;
      }
    },
    handleExceed() {
      this.$message.warning("最多只能上传10个文件，请删除后在上传");
    },
    //自定义上传
    handleCustomUpload(content) {
      uploadImg(content)
        .then((res) => {
          content.onSuccess(res.data);
        })
        .catch((err) => {
          content.onError(err);
        });
    },
    //图片上传成功
    handleImgSuccess(file, type) {
      switch (type) {
        case "businessLicenseUrl":
          this.form.businessLicenseUrl = file.url;
          this.disBusinessLicense(file.url);
          break;
        case "cardPortraitUrl":
          this.disIdcard(file.url, "cardPortraitUrl");
          break;
        case "cardEmblemUrl":
          this.disIdcard(file.url, "cardEmblemUrl");
          break;
        case "directorHeadUrl":
          this.form.directorHeadUrl = file.url;
          break;
        case "honor":
          this.cooHonorFileList.push({
            id: "",
            applyId: "",
            fileType: 2,
            url: file.url,
            name: file.title,
          });
          break;
        case "premises":
          this.cooBusinessPlaceFileList.push({
            id: "",
            applyId: "",
            fileType: 3,
            url: file.url,
            name: file.title,
          });
          break;
      }
    },
    /**
     * @description: 打开定位地图
     * @Author: quwandong
     * @Date: 2022-12-29 11:33:13
     */
    openQueryMap() {
      const checkedNodes = this.$refs.regionCascader.getCheckedNodes();
      let checkedRegionStr = "";
      if (checkedNodes[0]) {
        checkedRegionStr = checkedNodes[0].pathLabels.join("");
      }
      this.$refs.queryMap.openDialog(checkedRegionStr);
    },
    /**
     * @description:
     * @param {*} address
     * @Author: quwandong
     * @Date: 2022-12-29 11:35:51
     */
    onConfirmSelectAddress(addressDetail) {
      this.centreAddress = addressDetail.name
        ? addressDetail.address + addressDetail.name
        : addressDetail.address;
      this.form.centre = `${addressDetail.lonlat.lng},${addressDetail.lonlat.lat}`;
      this.$refs.form.validateField("centre");
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  padding: 0 !important;

  .apply-info {
    display: flex;
    align-items: center;
    padding: 10px 0;

    .status {
      font-size: 20px;
      font-weight: bold;
      color: #018388;
      display: flex;
      align-items: center;
      padding-right: 48px;
      position: relative;

      .icon {
        height: 42px;
        margin-right: 8px;
      }

      &:after {
        content: "";
        display: inline-block;
        width: 1px;
        height: 26px;
        background: #aeaeae;
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -13px;
      }
    }

    .info {
      span {
        font-size: 16px;
        color: #222222;
        margin: 0 40px;
      }
    }
  }

  // .tip-txt{
  //   margin-top: 15px;
  //   color: #E00000;
  //   font-size: 14px;
  // }
  .plate {
    padding: 10px 20px;

    .title {
      font-size: 18px;
      color: #333333;
      font-weight: bold;
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      label {
        font-size: 16px;
        color: #999999;
      }

      &:before {
        content: "";
        display: inline-block;
        width: 5px;
        height: 18px;
        background: #018388;
        border-radius: 3px;
        margin-right: 5px;
      }
    }
  }
}

.form {
  .el-form-item {
    width: 600px;
    &.map-form-item {
      width: auto;
    }
    .el-input,
    .el-select,
    .el-cascader {
      width: 360px;
    }

    &.w100 {
      width: 100%;
    }
  }
}

.foot-btns {
  text-align: center;
  padding: 20px 0;

  .el-button {
    width: 120px;
    height: 48px;
    font-size: 18px;
    border: none;

    &.btn-cancel {
      background: #bababa;
    }

    &.btn-refuse {
      background: #df3b3b;
    }

    &.btn-pass {
      background: #018388;
    }
  }
}

::v-deep {
  .map-address {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #222222;
    margin-left: 50px;

    i {
      display: inline-block;
      margin-left: 10px;
      width: 14px;
      height: 18px;
      background: url("~@/assets/weizhi_fanhui.png");
      background-size: 100% 100%;
    }

    > span {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #048489;
    }
  }
}

.dialog-refuse {
  .top {
    font-size: 16px;
    color: #222222;
  }

  .el-form {
    margin-top: 20px;
  }
}
</style>
